import { CLIENT_ID, CLOUD_API_URL, PROJECT_ID } from '@/lib/cloud-api-config';

function publicHeaders(): Record<string, string> {
  return {
    'Content-Type': 'application/json',
    ...(CLIENT_ID ? { 'X-Client-Id': CLIENT_ID, 'X-Project-Id': CLIENT_ID } : {}),
    'x-request-id': crypto.randomUUID(),
  };
}

async function parseApiError(res: Response): Promise<string> {
  const text = await res.text();
  try {
    const err = JSON.parse(text) as { detail?: string; msg?: string; message?: string };
    return err.detail || err.msg || err.message || `请求失败: ${res.status}`;
  } catch {
    return text || `请求失败: ${res.status}`;
  }
}

async function cloudPost<T>(path: string, body: Record<string, unknown>): Promise<T> {
  const res = await fetch(`${CLOUD_API_URL}${path}`, {
    method: 'POST',
    headers: publicHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    throw new Error(await parseApiError(res));
  }
  return res.json() as Promise<T>;
}

export async function sendEmailCode(email: string): Promise<{ messageId: string }> {
  const trimmed = email.trim();
  if (!trimmed) {
    throw new Error('请输入邮箱');
  }
  return cloudPost<{ messageId: string }>('/mailer/sendCode', {
    projectId: PROJECT_ID,
    email: trimmed,
  });
}

export async function loginWithEmail(params: {
  email: string;
  messageId: string;
  code: string;
}): Promise<unknown> {
  const trimmedEmail = params.email.trim();
  const trimmedCode = params.code.trim();
  if (!trimmedEmail || !params.messageId || !trimmedCode) {
    throw new Error('请填写邮箱与验证码');
  }
  return cloudPost('/v1/public/accounts/login-with-email', {
    projectId: PROJECT_ID,
    email: trimmedEmail,
    messageId: params.messageId,
    code: trimmedCode,
  });
}
